import { LicenseFeatureName } from "~/modules/license/models/LicenseFeatureName.enum";

export const PATH_PARAMETERS_LICENSE = "/parameters/license";

/**
 * List of license feature gauges we want to display
 * in the front
 * We need this list because we don't want to display all the features and total can be undefined even if we have a limit
 */
export const LICENSE_FEATURE_GAUGES: LicenseFeatureName[] = [
  LicenseFeatureName.INTERFACES_THIRD_PARTY,
];
